<div class="flex items-center space-x-3">
    <img src="{{ item.icon.uri }}" alt="{{ item.icon.alt }}" class="w-5 h-5" />
    @if (!isCollapsed) {
        <span
            class="font-medium text-tertiary-800 text-sm focus:outline-none"
            >{{ item.link.text }}</span
        >
    }
</div>
